import request from "@/utils/oms-request";
import download from "@/utils/oms-download";

// 客人包装资料-更新备注
export const updatePackageInfoRemark = (data: any) =>
  request({
    url: "/customer-pack-info",
    method: "put",
    data
  });
//装箱资料-列表
export const getPackageInfo = (params: any) =>
  request({
    url: "/package-info",
    method: "get",
    params
  });
// 装箱资料-备注
export const updatePackageRemark = (id: any, data: any) =>
  request({
    url: `/package-info/${id}/remark`,
    method: "put",
    data
  });
// 装箱资料-删除
export const deletePackageInfo = (params: any) =>
  request({
    url: `/package-info?${params}`,
    method: "delete"
  });
// 装箱资料-下载所有型号
export const downloadPackageInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/package-info/download`,
    method: "get",
    params
  });
// 装箱资料-上传
export const uploadPackageInfo = (data: any) =>
  request({
    url: "/package-info/upload",
    method: "put",
    data
  });
// 装箱资料-查看详情
export const getPackageInfoDetails = (id: any) =>
  request({
    url: `/package-info/${id}`,
    method: "get"
  });
// 装箱资料-编辑
export const editPackageInfo = (id: any, data: any) =>
  request({
    url: `/package-info/${id}`,
    method: "put",
    data
  });
// 包装类型 /package-info/package-type
export const getPackageType = () =>
  request({
    url: "/package-info/package-type",
    method: "get"
  });
//壳体包装-列表
export const getShellPackageInfo = (params: any) =>
  request({
    url: "/package-info/shell-package-info",
    method: "get",
    params
  });
//壳体包装-上传维护
export const uploadShellPackageInfo = (data: any) =>
  request({
    url: "/package-info/shell-package/upload",
    method: "put",
    data
  });
// 壳体包装-删除
export const deleteShellPackageInfo = (params: any) =>
  request({
    url: `/package-info/shell-package-info?${params}`,
    method: "delete"
  });
// 壳体包装-下载
export const downloadShellPackageInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/package-info/shell-package-info/excel`,
    method: "get",
    params
  });
// 壳体包装-查看详情
export const getShellPackageInfoDetails = (id: any) =>
  request({
    url: `/package-info/shell-package-info/${id}/details`,
    method: "get"
  });

// 壳体包装-编辑
export const editShellPackageInfo = (data: any) =>
  request({
    url: "/package-info/shell-package-info",
    method: "put",
    data
  });

// 额外信息列表查询
export const getOtherInfo = (params: any) =>
  request({
    url: "/package-info/other-info/search",
    method: "get",
    params
  });
// 额外信息 - 下载
export const downloadOtherInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/package-info/other-info/download`,
    method: "get",
    params
  });
// 批量删除额外信息
export const deleteOtherInfo = (data: any) =>
  request({
    url: `/package-info/other-info`,
    method: "delete",
    data:{
      ids: data
    }
  });
// 查询单个产品的额外信息
export const getOtherInfoOne = (id: any) =>
  request({
    url: `/package-info/other-info/${id}`,
    method: "get"
  });
// 编辑额外信息
export const editOtherInfo = (id: any, data: any) =>
  request({
    url: `/package-info/other-info/${id}`,
    method: "put",
    data
  });
// 上传额外信息
export const uploadOtherInfo = (data: any) =>
  request({
    url: "/package-info/other-info",
    method: "post",
    data
  });
// 模糊查询供应商
export const fuzzyQuerySupplier = (brandId: string, keyword:string) =>
  request({
    url: `/package-info/other-info/fuzzy-supplier`,
    method: "get",
    params:{
      brandId:brandId,
      keyword:keyword
    }
  });

// 查询贴标资料
export const queryLabelInfos = (id:string) =>
  request({
    url: `/package-info/other-info/label-info`,
    method: "get",
    params:{
      id:id,
    }
  });

// 更新贴标资料
export const updateLabelInfos = (data: any) =>
  request({
    url: `/package-info/other-info/label-info`,
    method: "put",
    data
  });